import ChangePasswordPage from 'components/login/ChangePasswordPage'
import Login from 'components/login/Login'
import Logout from 'components/login/Logout'
import TwoFactorOneTimeCode from 'components/login/TwoFactorOneTimeCode'
import TwoFactorSecret from 'components/login/TwoFactorSecret'

export type LoginPageName =
    | 'login'
    | 'twoFactorSecret'
    | 'twoFactorOneTimeCode'
    | 'changePassword'
    | 'logout'

interface LoginPageProps {
    page?: LoginPageName
    /** For `changePassword`: the token from the link in a password mail. */
    token?: string
}

/**
 * The pages around logging in to office, each in a `LoginBox`.
 */
const LoginPage = ({ page = 'login', token }: LoginPageProps) => (
    <div className="flex min-h-full items-start justify-center px-4 pb-8 pt-[6vh]">
        {(() => {
            switch (page) {
                case 'twoFactorSecret':
                    return <TwoFactorSecret />
                case 'twoFactorOneTimeCode':
                    return <TwoFactorOneTimeCode />
                case 'changePassword':
                    return <ChangePasswordPage token={token} />
                case 'logout':
                    return <Logout />
                default:
                    return <Login />
            }
        })()}
    </div>
)

export default LoginPage
